<script setup>
</script>

<template>
  <div class="bg-image"></div>
  <div class="bg-overlay"></div>
  <div class="bg-vignette"></div>
</template>

<style>
.bg-image {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    background: url('/title-background.jpg') center center / cover no-repeat;
    z-index: -2;
    filter: brightness(0.7) saturate(1.1);
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
}

.bg-image.market-bg {
    background: url('/market-bg.jpg') center center / cover no-repeat;
}

.bg-overlay {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(0,0,0,0.7) 0%, rgba(0,20,40,0.5) 50%, rgba(0,0,0,0.8) 100%);
    z-index: -1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
}

.bg-vignette {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(ellipse at center, transparent 40%, rgba(0,0,0,0.6) 100%);
    z-index: -1;
    pointer-events: none;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
}
</style>
